import { Pipe, PipeTransform } from "@angular/core";
import { flow, trim, truncate } from "lodash-es";

@Pipe({
	name: "truncate",
})
export class TruncatePipe implements PipeTransform {
	transform(value: string, length?: number, suffix = ""): string {
		return flow(
			(x: string) =>
				truncate(x, {
					length: length || 25,
					omission: suffix,
				}),
			trim
		)(value);
	}
}
